// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__24Tk-","question":"Question_question__1MvTq","description":"Question_description__1q6--"};